import { useQueryClient } from '@tanstack/react-query'

import type { Perk } from '../../hooks/types'

export const useAllPerks = () => {
  const queryClient = useQueryClient()

  const allPerks = queryClient
    .getQueriesData<{ perks: Perk[] }>(['tierPerks'])
    .reduce((sum, tierPerks) => {
      if (tierPerks[1]?.perks) {
        return [...sum, ...tierPerks[1].perks]
      }

      return [...sum]
    }, [] as Perk[])

  return {
    allPerks,
    getPerk: (perkType: Perk['type']) => allPerks.find((perk) => perk.type === perkType),
  }
}
